import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import * as PIXI from "pixi.js";
import { SlingoLang } from "../lang/SlingoLang";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractWinDisplayProperties.ts
 */
export class AbstractWinDisplayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.winBackgroundProperties.equals(other.winBackgroundProperties) &&
            this.winLabelFieldProperties.equals(other.winLabelFieldProperties) &&
            this.winFieldProperties.equals(other.winFieldProperties) &&
            this.gameOverProperties.equals(other.gameOverProperties) &&
            this.gameOverFieldProperties.equals(other.gameOverFieldProperties) &&
            this.gameSummaryScale.equals(other.gameSummaryScale) &&
            (this.jokerWinDelay === other.jokerWinDelay);
    }
    setDefaultValues() {
        this.gameOverProperties = new SpriteProperties(SlingoStyle.GAME_OVER, SlingoStyle.MODULE);
        this.gameOverFieldProperties = new TextFieldProperties(FontStyle.GAME_OVER, null, SlingoLang.GAME_OVER, ControlConstants.CENTER, ControlConstants.CENTER);
        this.gameSummaryScale = new PIXI.Point(0.5, 1.15);
        this.jokerWinDelay = 1500;
    }
}
//# sourceMappingURL=AbstractWinDisplayProperties.js.map